<template lang="pug">
  table.table.table--bars
    thead
      tr.table__row.table__row--head
        th.table__cell {{ 'base.animal_type' | translate }}
        th.table__cell {{ 'base.animal_count' | translate }}
        th.table__cell
    v-table-body(
      :cols="3"
      :empty="!items.length"
      :loading="!loaded")
      tr.table__row(
        v-for="item in items"
        :key="item.id")
        td.table__cell {{ item.name | shortstr }}
        td.table__cell {{ item.animal_count || 0 }}
        td.table__cell.table__cell--action
          v-btn(
            v-if="allowEdit && !isConsultant && userType !== 'employee'"
            icon
            @click="selectAnimalType(item.id)")
            v-icon(
              font-size="1"
              icon="cog")
    ui-pagination(
      v-if="showPagination"
      v-model="page"
      :page-count="pageCount"
      @page-change="pageChangeHandler")
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import paginationMixin from '@/mixins/pagination.mixin'
import api from '@/api'
import UiPagination from '@/components/ui/ui-pagination/UiPagination.vue'

export default {
  name: 'TypesTable',

  mixins: [paginationMixin],
  components: {
    UiPagination
  },
  data: () => ({
    // page: 1,
    userType: null,
    loaded: false
  }),
  async created () {
    try {
      const { data } = await api.account.get()

      this.userType = data.user_type
    } catch (error) {
      console.error('Failed to fetch user type:', error)
      this.userType = null
    }
  },

  mounted () {
    this.setupPagination(api.animaltypes.list, {
      page: this.page > 1 ? this.page : null
    }).then(() => {
      this.loaded = true
    })
    // if (this.allowView) {
    //   this.loadDataList()
    // } else {
    //   this.loaded = true
    // }
  },

  methods: {
    ...mapActions('animaltypes', [
      'loadAnimalTypes',
      'selectAnimalType'
    ]),

    async loadDataList () {
      const params = {
        page: this.page > 1 ? this.page : null
      }
      await this.loadAnimalTypes(params)
      this.loaded = true
    },
    updateData () {
      this.setupPagination(api.animaltypes.list, {
        page: this.page > 1 ? this.page : null
      }).then(() => {
        this.loaded = true
      })
    }
  },

  computed: {
    ...mapGetters('animaltypes', [
      'animalTypes',
      'count'
    ]),

    allowEdit () {
      return this.hasPermission('animaltype', 'change')
    },

    allowView () {
      return this.hasPermission('animaltype', 'view')
    }
  }
}
</script>

<style lang="scss" scoped>
.table__cell:not(:last-child) {
  width: 50%;
}
</style>
